{
  "id": "to-editors",
  "label": "Till red-händelser",
  "singleItem": true,
  "planningTitleMirrors": ["assignmentTitle"],
  "memoTitlePattern": "Till red:",
  "planning": {
    "titlePattern": "Redaktionsmeddelande",
    "slugline": "tillred"
  },
  "sources": [
    { "type": "event", "newsvalues": ["3", "4", "5", "6"] }
  ],
  "postamble": ["TT Nyhetsbyrån"],
  "blocks": [
    {
      "id": "events",
      "label": "Händelser",
      "preamble": [],
      "grouping": "none",
      "item": {
        "headline": "{headline} {publicDescription}",
        "headlineRole": "preamble",
        "lines": ["Tid: Klockan {time}", "Plats:"]
      },
      "eventTitleSections": []
    }
  ]
}
